import {useServerTime} from '@glark-newco/game-library';
import {useMemo} from 'react';
import {useGameEndTime} from '../state/GameTimerSlice';

export const useGameTimeExpired = (): boolean => {
    const gameOverTime = useGameEndTime();
    const serverTime = useServerTime();

    return useMemo(() => {
        if (!serverTime || !gameOverTime) {
            return false;
        }
        return serverTime.isAfter(gameOverTime);
    }, [serverTime, gameOverTime]);
};
